/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MonitoringTube
 */
export interface MonitoringTube {
  /**
   *
   * @type {string}
   * @memberof MonitoringTube
   */
  readonly uuid?: string;
  /**
   *
   * @type {string}
   * @memberof MonitoringTube
   */
  readonly gmwWellCode?: string;
  /**
   *
   * @type {string}
   * @memberof MonitoringTube
   */
  readonly gmwBroId?: string;
  /**
   *
   * @type {string}
   * @memberof MonitoringTube
   */
  readonly linkedGmns?: string;
  /**
   *
   * @type {Date}
   * @memberof MonitoringTube
   */
  readonly created?: Date;
  /**
   *
   * @type {Date}
   * @memberof MonitoringTube
   */
  readonly updated?: Date;
  /**
   *
   * @type {string}
   * @memberof MonitoringTube
   */
  tubeNumber?: string | null;
  /**
   *
   * @type {string}
   * @memberof MonitoringTube
   */
  tubeType?: string | null;
  /**
   *
   * @type {string}
   * @memberof MonitoringTube
   */
  artesianWellCapPresent?: string | null;
  /**
   *
   * @type {string}
   * @memberof MonitoringTube
   */
  sedimentSumpPresent?: string | null;
  /**
   *
   * @type {string}
   * @memberof MonitoringTube
   */
  sedimentSumpLength?: string | null;
  /**
   *
   * @type {string}
   * @memberof MonitoringTube
   */
  numberOfGeoOhmCables?: string | null;
  /**
   *
   * @type {object}
   * @memberof MonitoringTube
   */
  geoOhmCables?: object;
  /**
   *
   * @type {string}
   * @memberof MonitoringTube
   */
  tubeTopDiameter?: string | null;
  /**
   *
   * @type {string}
   * @memberof MonitoringTube
   */
  variableDiameter?: string | null;
  /**
   *
   * @type {string}
   * @memberof MonitoringTube
   */
  tubeStatus?: string | null;
  /**
   *
   * @type {string}
   * @memberof MonitoringTube
   */
  tubeTopPosition?: string | null;
  /**
   *
   * @type {string}
   * @memberof MonitoringTube
   */
  tubeTopPositioningMethod?: string | null;
  /**
   *
   * @type {string}
   * @memberof MonitoringTube
   */
  tubePartInserted?: string | null;
  /**
   *
   * @type {string}
   * @memberof MonitoringTube
   */
  tubeInUse?: string | null;
  /**
   *
   * @type {string}
   * @memberof MonitoringTube
   */
  tubePackingMaterial?: string | null;
  /**
   *
   * @type {string}
   * @memberof MonitoringTube
   */
  tubeMaterial?: string | null;
  /**
   *
   * @type {string}
   * @memberof MonitoringTube
   */
  glue?: string | null;
  /**
   *
   * @type {string}
   * @memberof MonitoringTube
   */
  screenLength?: string | null;
  /**
   *
   * @type {string}
   * @memberof MonitoringTube
   */
  screenProtection?: string | null;
  /**
   *
   * @type {string}
   * @memberof MonitoringTube
   */
  sockMaterial?: string | null;
  /**
   *
   * @type {string}
   * @memberof MonitoringTube
   */
  screenTopPosition?: string | null;
  /**
   *
   * @type {string}
   * @memberof MonitoringTube
   */
  screenBottomPosition?: string | null;
  /**
   *
   * @type {string}
   * @memberof MonitoringTube
   */
  plainTubePartLength?: string | null;
  /**
   *
   * @type {string}
   * @memberof MonitoringTube
   */
  gmw: string;
  /**
   *
   * @type {string}
   * @memberof MonitoringTube
   */
  dataOwner: string;
}

/**
 * Check if a given object implements the MonitoringTube interface.
 */
export function instanceOfMonitoringTube(value: object): value is MonitoringTube {
  if (!("gmw" in value) || value["gmw"] === undefined) return false;
  if (
    (!("dataOwner" in (value as Record<string, any>)) &&
      !("data_owner" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["dataOwner"] === undefined &&
      (value as Record<string, any>)["data_owner"] === undefined)
  )
    return false;
  return true;
}

export function MonitoringTubeFromJSON(json: any): MonitoringTube {
  return MonitoringTubeFromJSONTyped(json, false);
}

export function MonitoringTubeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MonitoringTube {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    gmwWellCode: json["gmw_well_code"] == null ? undefined : json["gmw_well_code"],
    gmwBroId: json["gmw_bro_id"] == null ? undefined : json["gmw_bro_id"],
    linkedGmns: json["linked_gmns"] == null ? undefined : json["linked_gmns"],
    created: json["created"] == null ? undefined : new Date(json["created"]),
    updated: json["updated"] == null ? undefined : new Date(json["updated"]),
    tubeNumber:
      json["tube_number"] === undefined
        ? undefined
        : json["tube_number"] === null
        ? null
        : json["tube_number"],
    tubeType:
      json["tube_type"] === undefined
        ? undefined
        : json["tube_type"] === null
        ? null
        : json["tube_type"],
    artesianWellCapPresent:
      json["artesian_well_cap_present"] === undefined
        ? undefined
        : json["artesian_well_cap_present"] === null
        ? null
        : json["artesian_well_cap_present"],
    sedimentSumpPresent:
      json["sediment_sump_present"] === undefined
        ? undefined
        : json["sediment_sump_present"] === null
        ? null
        : json["sediment_sump_present"],
    sedimentSumpLength:
      json["sediment_sump_length"] === undefined
        ? undefined
        : json["sediment_sump_length"] === null
        ? null
        : json["sediment_sump_length"],
    numberOfGeoOhmCables:
      json["number_of_geo_ohm_cables"] === undefined
        ? undefined
        : json["number_of_geo_ohm_cables"] === null
        ? null
        : json["number_of_geo_ohm_cables"],
    geoOhmCables: json["geo_ohm_cables"] == null ? undefined : json["geo_ohm_cables"],
    tubeTopDiameter:
      json["tube_top_diameter"] === undefined
        ? undefined
        : json["tube_top_diameter"] === null
        ? null
        : json["tube_top_diameter"],
    variableDiameter:
      json["variable_diameter"] === undefined
        ? undefined
        : json["variable_diameter"] === null
        ? null
        : json["variable_diameter"],
    tubeStatus:
      json["tube_status"] === undefined
        ? undefined
        : json["tube_status"] === null
        ? null
        : json["tube_status"],
    tubeTopPosition:
      json["tube_top_position"] === undefined
        ? undefined
        : json["tube_top_position"] === null
        ? null
        : json["tube_top_position"],
    tubeTopPositioningMethod:
      json["tube_top_positioning_method"] === undefined
        ? undefined
        : json["tube_top_positioning_method"] === null
        ? null
        : json["tube_top_positioning_method"],
    tubePartInserted:
      json["tube_part_inserted"] === undefined
        ? undefined
        : json["tube_part_inserted"] === null
        ? null
        : json["tube_part_inserted"],
    tubeInUse:
      json["tube_in_use"] === undefined
        ? undefined
        : json["tube_in_use"] === null
        ? null
        : json["tube_in_use"],
    tubePackingMaterial:
      json["tube_packing_material"] === undefined
        ? undefined
        : json["tube_packing_material"] === null
        ? null
        : json["tube_packing_material"],
    tubeMaterial:
      json["tube_material"] === undefined
        ? undefined
        : json["tube_material"] === null
        ? null
        : json["tube_material"],
    glue: json["glue"] === undefined ? undefined : json["glue"] === null ? null : json["glue"],
    screenLength:
      json["screen_length"] === undefined
        ? undefined
        : json["screen_length"] === null
        ? null
        : json["screen_length"],
    screenProtection:
      json["screen_protection"] === undefined
        ? undefined
        : json["screen_protection"] === null
        ? null
        : json["screen_protection"],
    sockMaterial:
      json["sock_material"] === undefined
        ? undefined
        : json["sock_material"] === null
        ? null
        : json["sock_material"],
    screenTopPosition:
      json["screen_top_position"] === undefined
        ? undefined
        : json["screen_top_position"] === null
        ? null
        : json["screen_top_position"],
    screenBottomPosition:
      json["screen_bottom_position"] === undefined
        ? undefined
        : json["screen_bottom_position"] === null
        ? null
        : json["screen_bottom_position"],
    plainTubePartLength:
      json["plain_tube_part_length"] === undefined
        ? undefined
        : json["plain_tube_part_length"] === null
        ? null
        : json["plain_tube_part_length"],
    gmw: json["gmw"],
    dataOwner: json["data_owner"],
  };
}

export function MonitoringTubeToJSON(json: any): MonitoringTube {
  return MonitoringTubeToJSONTyped(json, false);
}

export function MonitoringTubeToJSONTyped(
  value?: Omit<
    MonitoringTube,
    "uuid" | "gmw_well_code" | "gmw_bro_id" | "linked_gmns" | "created" | "updated"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    tube_number: value["tubeNumber"],
    tube_type: value["tubeType"],
    artesian_well_cap_present: value["artesianWellCapPresent"],
    sediment_sump_present: value["sedimentSumpPresent"],
    sediment_sump_length: value["sedimentSumpLength"],
    number_of_geo_ohm_cables: value["numberOfGeoOhmCables"],
    geo_ohm_cables: value["geoOhmCables"],
    tube_top_diameter: value["tubeTopDiameter"],
    variable_diameter: value["variableDiameter"],
    tube_status: value["tubeStatus"],
    tube_top_position: value["tubeTopPosition"],
    tube_top_positioning_method: value["tubeTopPositioningMethod"],
    tube_part_inserted: value["tubePartInserted"],
    tube_in_use: value["tubeInUse"],
    tube_packing_material: value["tubePackingMaterial"],
    tube_material: value["tubeMaterial"],
    glue: value["glue"],
    screen_length: value["screenLength"],
    screen_protection: value["screenProtection"],
    sock_material: value["sockMaterial"],
    screen_top_position: value["screenTopPosition"],
    screen_bottom_position: value["screenBottomPosition"],
    plain_tube_part_length: value["plainTubePartLength"],
    gmw: value["gmw"],
    data_owner: value["dataOwner"],
  };
}
